// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { SsoIntroComponent } from './sso-setup-container/sso-intro/sso-intro.component';
import { MaterialModule } from '../shared/material.module';
import { SharedModule } from '../shared/shared.module';
import { LoginModule } from '../login/login.module';
import { StellantisHeaderComponent } from './stellantis-header/stellantis-header.component';
import { SsoSetupContainerComponent } from './sso-setup-container/sso-setup-container.component';
import { SsoSetUpComponent } from './sso-setup-container/sso-set-up/sso-set-up.component';
import { SSOSuccessComponent } from './sso-setup-container/sso-success/sso-success.component';
import { DPAComponent } from './sso-setup-container/dpa/dpa.component';
import { SsoSignatureComponent } from './sso-setup-container/sso-signature-setup/sso-signature-setup.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { BuyerDashboardModule } from '../buyer-dashboard/buyer-dashboard.module';
import { SsoSignatureFormComponent } from './sso-signature-form/sso-signature-form.component';

@NgModule({
    declarations: [
        DPAComponent,
        SsoIntroComponent,
        SsoSetUpComponent,
        SsoSetupContainerComponent,
        SSOSuccessComponent,
        SsoSignatureComponent,
        StellantisHeaderComponent,
        SsoSignatureFormComponent,
    ],
    imports: [
        BrowserAnimationsModule,
        BrowserModule,
        CommonModule,
        FormsModule,
        LoginModule,
        MaterialModule,
        ReactiveFormsModule,
        RouterModule,
        BuyerDashboardModule,
        SharedModule,
    ],
})
export class SsoModule {}
